import React from "react";
import { RequestData } from "./RequestData";

export function AddedAIToBoundPolicyNotification(props: {
  Name: string;
  EmailAddress: string;
  RequestData: RequestData;
}) {
  return (
    <div className="successBox">
      {props.Name} has been added as an Additional Insured. A copy of your new
      certificate has been emailed to {props.EmailAddress}. Thanks for
      purchasing insurance through {props.RequestData.ProducerName}.
    </div>
  );
}
